import { render, staticRenderFns } from "./SearchInspectionsPage.vue?vue&type=template&id=404ccc48&"
import script from "./SearchInspectionsPage.vue?vue&type=script&lang=js&"
export * from "./SearchInspectionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports